import createStatusTextCue, { ERROR_OUTLINE_ICON_PATH } from './statusTextCue';

export default function createErrorTextCue() {
    return createStatusTextCue(ERROR_OUTLINE_ICON_PATH);
}
